// removed by extract-text-webpack-plugin
module.exports = {"container":"f6f02e6968_src-common-PageLayout-_AlertBanner_container","wrapper":"_5969cefcc8_src-common-PageLayout-_AlertBanner_wrapper","content":"_09a39b2a5e_src-common-PageLayout-_AlertBanner_content"};


//////////////////
// WEBPACK FOOTER
// ./src/common/PageLayout/AlertBanner.css
// module id = 969
// module chunks = 0